import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

const BASE_NOTIFICATIONS_URL = `${environment.apiUrl}/notifications`;

@Injectable({ providedIn: "root" })
export class NotificationsService {
  constructor(public _http: HttpClient) {}

  hasNotifications(): Promise<any> {
    return this._http.get(`${BASE_NOTIFICATIONS_URL}/check`).toPromise();
  }

  getNotifications(currLength = "0", conversationUuid = null): Promise<any> {
    return this._http
      .post(`${BASE_NOTIFICATIONS_URL}/all`, { currLength, conversationUuid })
      .toPromise();
  }

  markAsRead(conversationUuid = null): Promise<any> {
    return this._http
      .post(`${BASE_NOTIFICATIONS_URL}/read`, {
        conversationUuid: conversationUuid,
      })
      .toPromise();
  }

  getFollowSettings(): Promise<any> {
    return this._http.get(`${BASE_NOTIFICATIONS_URL}/settings`).toPromise();
  }

  setDefaultFollowBehavior(behavior: boolean): Observable<any> {
    return this._http.post(`${BASE_NOTIFICATIONS_URL}/settings`, { behavior });
  }

  setConversationFollowBehavior(
    workspaceUuid: string,
    behavior: boolean
  ): Observable<any> {
    return this._http.patch(
      `${BASE_NOTIFICATIONS_URL}/settings/follow/${workspaceUuid}`,
      { behavior }
    );
  }
}
